<template>
  <div>
    <topbar drawer :title="navbarTitle"></topbar>
    <v-container v-if="!loading">
      <v-row>
        <v-col>
          <v-skeleton-loader elevation="2" type="card" :loading="false" color="lightgreen">
            <v-img
              src="https://cdn-akebd.nitrocdn.com/bCWGvmHIgAlrWzdjLoGQbzvNeZiguKmJ/assets/static/optimized/rev-cedab1e/wp-content/uploads/2015/08/Tools-for-content-marketers-header-image.jpg"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="200px"
            >
              <v-card-title class="text-h5">Tools</v-card-title>
              <v-card-subtitle>Hier kannst du die Links vom Discord Channel "linksammlung" bearbeiten</v-card-subtitle>
            </v-img>
            <v-card-text>
              <v-list three-line>
                <draggable
                  v-model="tools"
                  handle=".handle"
                  v-bind="dragOptions"
                  @start="drag = true"
                  @end="onDragEnd"
                >
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(item, index) in tools" :key="index">
                      <v-list-item>
                        <template v-if="!editActive.includes(item.id)">
                          <v-list-item-icon style="width: 5px">
                            <v-icon :style="{pointerEvents: drag ? '' : 'none'}" class="mr-4 move--btn handle" size="medium">fa-arrows-alt</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{item.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle><a :href="item.url" target="_blank">{{item.url}}</a></v-list-item-subtitle>
                            <v-list-item-subtitle>Hinzugefügt von: {{item.userName}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click="onEdit(item.id)">
                              <v-icon color="yellow darken-3">
                                fa-edit
                              </v-icon>
                            </v-btn>
                          </v-list-item-action>
                          <v-list-item-action>
                            <v-btn icon @click="onDelete(item.id)">
                              <v-icon color="yellow darken-3">
                                fa-trash
                              </v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </template>
                        <div style="width: 100%" :hidden="!editActive.includes(item.id)">
                          <v-list-item-content>
                            <ValidationObserver ref="observer">
                              <ValidationProvider v-slot="{ errors }" rules="required" name="name">
                                <v-text-field
                                  v-model="item.name"
                                  label="Name"
                                  :error-messages="errors"
                                  outlined
                                  required
                                  hint="Name des Tools"
                                ></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider v-slot="{ errors }" rules="required" name="description">
                                <v-text-field
                                  v-model="item.description"
                                  label="Beschreibung"
                                  :error-messages="errors"
                                  outlined
                                  required
                                  hint="Beschreibung zum Tool"
                                ></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider v-slot="{ errors }" rules="required" name="link">
                                <v-text-field
                                  v-model="item.url"
                                  label="Link"
                                  :error-messages="errors"
                                  outlined
                                  required
                                  hint="Link zum Tool"
                                ></v-text-field>
                              </ValidationProvider>
                            </ValidationObserver>
                            <div>
                              <v-btn class="mr-4" @click="onSave(item, index)">
                                <v-icon left color="yellow darken-3">
                                  fa-save
                                </v-icon>
                                Save
                              </v-btn>
                              <v-btn @click="onCancel(item)">
                                <v-icon left color="yellow darken-3">
                                  fa-times-circle
                                </v-icon>
                                cancel
                              </v-btn>
                            </div>
                          </v-list-item-content>
                        </div>
                      </v-list-item>
                      <v-divider v-if="index < tools.length - 1" :key="index"></v-divider>
                    </div>
                  </transition-group>
                </draggable>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-btn class="ml-auto" color="primary" @click="addItem">
                <v-icon left small>
                  fa-plus
                </v-icon>
                Tool hinzufügen
              </v-btn>
            </v-card-actions>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Topbar from '../components/Topbar';
  import {ValidationObserver, ValidationProvider} from 'vee-validate';
  import draggable from 'vuedraggable';
  import { nanoid } from 'nanoid';

  export default {
    name: 'Discord',

    components: {
      ValidationObserver,
      ValidationProvider,
      Topbar,
      draggable
    },
    data() {
      return {
        drag: true,
        editActive: [],
        navbarTitle: 'Discord Linksammlung',
        tools: [
          {
            description: "Optimized Star Citizen trade routes",
            id: "7000b062-a82c-4b2e-827c-1082c0e9fb52",
            name: "Trade Route Planer",
            url: "https://sc-trade.tools/home",
            userId: "755827963232256221",
            userName: "Bewareoblivionisathand"
          },
          {
            description: "Mining Calculator, Trade, Prices, Risks, Profitability, Mass to SCU Converter, Ships List, SCU, Prices and more",
            id: "c2fa14be-15ff-4dc2-a403-a9053caa5447",
            name: "uexcorp",
            url: "https://uexcorp.space/",
            userId: "755827963232256221",
            userName: "Bewareoblivionisathand"
          }
        ]
      };
    },

    computed: {
      loading() {
        return this.$store.getters.loading;
      },
      dragOptions() {
        return {
          animation: 200,
          disabled: false,
          ghostClass: 'ghost'
        };
      }
    },

    methods: {
      async onSave(item, index) {
        const formValid = await this.$refs.observer[index].validate();
        if (!formValid) {
          return;
        }
        this.editActive = this.editActive.filter((itm) => itm !== item.id);
        let form = JSON.parse(JSON.stringify(item));
        if (item.newItem) {
          delete form.newItem;
        }
        // send form
      },
      onCancel(item) {
        this.editActive = this.editActive.filter((itm) => itm !== item.id);
        if (item.newItem) {
          this.tools = this.tools.filter((itm) => itm.id !== item.id);
        }
      },
      addItem() {
        const newItem = {
          id: nanoid(),
          name: '',
          description: '',
          url: '',
          userId: '',
          userName: '',
          newItem: true
        }
        this.editActive.push(newItem.id);
        this.tools.push(newItem);
        // add tools
      },
      onEdit(id) {
        if (this.editActive.includes(id)) {
          this.editActive = this.editActive.filter((item) => item !== id);
          return
        }
        this.editActive.push(id);
      },
      onDelete(id) {
        // await delete item
        this.editActive = this.editActive.filter((item) => item !== id);
      },
      onDragEnd() {
        this.drag = false;
        // AWAIT SAVE CHANGES
        this.drag = true;
      }
    }
  };
</script>

<style lang="scss">
  .move--btn {
    cursor: move !important;
    margin-right: auto;
  }
</style>
